// Module
var code = "<template> <div class=\"page-not-found column flex-grow-1 align-items-middle justify-content-center animation-slide-from-top\"> <h1 class=\"title\">Page not found!</h1> <comp-button value=\"Go back home\" click.delegate=\"navigateBackHome()\"></comp-button> </div> </template>";
// Exports
module.exports = code;